import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable, catchError, filter, map, of, switchMap, take } from 'rxjs';
import { AuthService } from '@auth0/auth0-angular'
import { AuthService as Auth } from '../services/auth.service';
import { UserAccessService } from '../services/user-access.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  constructor(private authService: AuthService, private auth: Auth, private userAccess: UserAccessService, private router: Router) { }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    //if (this.authService.isAuthenticated)) {
    //   return true;
    // } else {
    //   // Redirect to the login page if not logged in
    //   return this.router.createUrlTree(['/login']);
    // }
    return this.authService.isAuthenticated$.pipe(switchMap(isAuthenticated => {
      if (!isAuthenticated) {
        this.auth.isLoggedInValue = false;
        return of(this.router.createUrlTree(['/login']));
      }
      return this.authService.user$.pipe(
        filter(user => user !== undefined),
        take(1),
        switchMap(user => this.userAccess.canLogin(user?.email ?? null)),
        map(isAllowed => {
          this.auth.isLoggedInValue = isAllowed;

          if (!isAllowed) {
            return this.router.createUrlTree(['/login'], {
              queryParams: { unauthorized: 'true' }
            });
          }

          return true;
        }),
        catchError(err => {
          console.error('Error checking user access:', err);
          this.auth.isLoggedInValue = false;
          return of(this.router.createUrlTree(['/login'], {
            queryParams: { error: 'access-check-failed' }
          }));
        })
      );
    }));
  }
}
